import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Rocket, Home, ArrowLeft, Compass } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen cosmic-bg relative overflow-hidden text-white flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="stars-bg" />
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full blur-3xl"
             style={{ background: 'radial-gradient(circle, rgba(123,47,247,.5), transparent 60%)' }} />
        <div className="absolute -bottom-32 -left-32 w-[440px] h-[440px] rounded-full blur-3xl"
             style={{ background: 'radial-gradient(circle, rgba(0,198,255,.4), transparent 60%)' }} />
      </div>

      <div className="relative z-10 text-center max-w-xl">
        <div className="mx-auto w-24 h-24 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mb-6 animate-pulse">
          <Compass size={42} className="text-fuchsia-300" />
        </div>

        <div className="font-display font-extrabold text-7xl md:text-8xl bg-gradient-to-r from-fuchsia-400 via-cyan-400 to-amber-300 bg-clip-text text-transparent leading-none">
          404
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-bold mt-4">
          This planet doesn’t exist
        </h1>
        <p className="text-white/60 mt-3">
          Looks like you’ve drifted into uncharted space. The page or planet you’re looking for may have been renamed, removed or never existed.
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            data-testid="not-found-back-btn"
            className="rounded-full border-white/15 bg-white/5 hover:bg-white/10 text-white"
          >
            <ArrowLeft size={14} className="mr-2" /> Go back
          </Button>
          <Link to="/">
            <Button
              data-testid="not-found-home-btn"
              className="rounded-full bg-gradient-to-r from-fuchsia-500 to-cyan-500 text-white border-0"
            >
              <Home size={14} className="mr-2" /> Back to landing
            </Button>
          </Link>
          <Link to="/app/planets">
            <Button
              variant="outline"
              data-testid="not-found-explore-btn"
              className="rounded-full border-white/15 bg-white/5 hover:bg-white/10 text-white"
            >
              <Rocket size={14} className="mr-2" /> Explore planets
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
